import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { Platform } from '@angular/cdk/platform';
import { LanguageService } from '../language/language.service';


@Injectable({
  providedIn: 'root'
})
export class CustomDateAdapterService extends NativeDateAdapter {

  constructor(
    platform: Platform, 
    private languageService: LanguageService
  ){
    // 1. Init with a fallback
    super('es', platform);
    // Subscribe to language changes
    this.languageService.getCurrentLanguageCode().subscribe(code => {
      this.setLocale(code); // This changes the language dinamically
    });
  }

  // This functions is automatically called by Angular when the "text" is going to be shown in the "button"
  override format(date: Date, displayFormat: Object): string {
    // If the format matches our custom one for month selector
    if (displayFormat === 'MONTH_YEAR_LABEL') {
      // Get the data to be displayed
      const year = date.getFullYear();
      const monthIndex = date.getMonth(); // 0 = January, 1 = February...
      // Create the custom string
      const monthName = date.toLocaleDateString(this.locale, { month: 'short' });
      return `${monthName}-${year}`;
    }
    // If the format matches our custom one for day and month selector
    if (displayFormat === 'DAY_MONTH_YEAR_LABEL') {
      const day = date.getDate();
      const year = date.getFullYear();
      const monthName = date.toLocaleDateString(this.locale, { month: 'short' });
      // Returns format like "15_feb-2026"
      return `${day}-${monthName}-${year}`;
    }

    // If it is not the custom format, do is as default (e.g. 10/1/2023)
    return super.format(date, displayFormat);
  }


  // This function is prepared to be called directly from components (not from angular)
  formatTimestampToLabel(timestamp: number): string {
    const date = new Date(timestamp);
    const day = date.getDate();
    let month = date.toLocaleDateString(this.locale, { month: 'short' })
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  
}
